import { InversionContainer } from '@/controller/container'
import { InjectionTokens } from '@/controller/tokens'

import { UniqueEntityID } from '@/domain/core'
import { UseCase } from '@/domain/core/UseCase'
import { Checklist } from '@/domain/models/Checklist'
import { Result } from '@/domain/protocols/Result'

import type { IChecklistRepository } from '@/data/ChecklistRepository/IChecklistRepository'

export class LoadChecklistUseCase implements UseCase<UniqueEntityID | string, Promise<Result<Checklist>>> {
  private repository: IChecklistRepository

  constructor(repository?: IChecklistRepository) {
    if (repository) {
      this.repository = repository
      return
    }
    const container = InversionContainer.getInstance().getContainer()
    this.repository = container.get<IChecklistRepository>(InjectionTokens.ChecklistRepository)
  }

  async execute(request: UniqueEntityID | string): Promise<Result<Checklist>> {
    try {
      const checklistId = request instanceof UniqueEntityID ? request : new UniqueEntityID(request)

      return await this.repository.getChecklist(checklistId)
    } catch (error) {
      return Result.fail(error)
    }
  }
}
